export const reddit = {
  "refreshToken": "34542178-J-ujSiWPsoBUdWxU6hm0ICVWdlY",
  "clientId": "bYcmUtL3mZ62yQ",
  "userAgent": "parm.app",
  "clientSecret": "J37GwZ9MlTy2qszs3w3RbvF4T5s"
};